export default {"src":"/_next/static/media/Trusty_logo_yellow.d0c6b18f.svg","height":60,"width":289,"blurWidth":0,"blurHeight":0};